import axios from "axios";
delete axios.defaults.headers.post["Content-Type"];
delete axios.defaults.headers.patch["Content-Type"];

export interface User {
  email: string;
  userid: string;
  groups: string[];
}

async function login(email: string, password: string): Promise<User> {
  const { data } = await axios.post("/1/api/login", { email, password });
  return data;
}

async function logout() {
  await axios.get("/1/api/logout");
}

async function generateHeaders(
  method: string,
  path: string,
  payload: Record<string, any> | string | null,
  contentType?: string
): Promise<{ authHeader: string; dateHeader: string }> {
  const { data } = await axios.post("/1/api/generate-headers", {
    method,
    url: `${document.location.origin}${path}`,
    payload,
    contentType,
  });
  return data;
}

async function authenticateRequest(
  method: "get" | "post" | "patch" | "delete",
  url: string,
  payload: Record<string, any> | string | null = null
): Promise<any> {
  const hasBody = !!payload;
  const contentType = hasBody ? "application/json" : undefined;
  const { authHeader, dateHeader } = await generateHeaders(
    method,
    url,
    payload,
    contentType
  );
  const headers: Record<string, any> = {
    Authorization: authHeader,
    "Roon-Date": dateHeader,
  };

  if (hasBody) {
    headers["Content-Type"] = contentType;
  }

  return axios.request({
    method,
    url,
    headers,
    data: payload,
  });
}

export default {
  login,
  logout,
  generateHeaders,
  authenticateRequest,
};
